export default {
  GET_LIST: '/manage/trade/deliverForm/findList',
  SAVE_DELIVERY: '/manage/trade/deliverForm/add',
  GET_DELIVERY_DETAIL: '/manage/trade/deliverForm/view',
  UPDATE_DELIVERY: '/manage/trade/deliverForm/edit',
  EXPORT: '/manage/trade/deliverForm/export'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/delivery.js